import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { CircleButton } from "../ecosystem";

const SingleUserSelector = ({isAdult}) => {

    return (<div className="header__single-user-selector">
        <CircleButton
            icon="new-patient"
            as={Link}
            to={{ pathname: '/familymanagement' }}
            disabled={!isAdult}
        />
    </div>);
}

export default withRouter(SingleUserSelector);
